import { Api } from "~/types/api/zebline-api";

export class GeneratedZeblineApi<SecurityDataType> extends Api<SecurityDataType> {
    constructor(baseUrl: string, zeblineLicenceCode: string) {
        super(baseUrl, zeblineLicenceCode);
    }
}